import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IUnifiedBackgroundCheckDateItem } from '../../../../core/interfaces/unified-background-check.interface';
import { optionStatusColor as resolveOptionStatusColor } from '../../driver-background-check.constants';
import { DriverBackgroundCheckStateService } from '../../driver-background-check-state.service';

@Component({
  selector: 'app-bgc-toolbar',
  templateUrl: './bgc-toolbar.component.html',
  styleUrls: ['./bgc-toolbar.component.scss', '../../driver-background-check.component.scss']
})
export class BgcToolbarComponent {
  @Input() form: FormGroup;
  @Input() reports: IUnifiedBackgroundCheckDateItem[];
  @Input() selectedReport: IUnifiedBackgroundCheckDateItem;
  @Input() hasReports: boolean;
  @Input() hasSelectedDetail: boolean;
  @Input() isComplete: boolean;
  @Input() noReportsFound: boolean;
  @Input() showReportDate: boolean;
  @Input() disabledButtonRunCheck: boolean;
  @Input() disabledButtonDownloadReport: boolean;
  @Input() piiToggleLabel: string;

  constructor(public stateService: DriverBackgroundCheckStateService) {}

  get isMaskPIIActive(): boolean {
    return this.form && this.form.get('maskPII').value;
  }

  optionStatusColor(report: IUnifiedBackgroundCheckDateItem): string {
    return resolveOptionStatusColor(report);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-toolbar/bgc-toolbar.component.ts